import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { setupAPIclient } from "../../services/setupAPIclient";
import LocalStorage from "../../helpers/localstorage";

// ---------- Paleta de cores ----------
const colors = {
  lightGray: "#F5F6FA",     // fundo de caixas e sidebar
  darkGray: "#7A7A7A",      // textos secundários
  red: "#E74C3C",            // botões e indicadores
};






// ---------- Estilos Globais ----------
const inputWrapperStyle = {
  display: "flex",
  alignItems: "center",
  border: `1px solid ${colors.red}`,
  borderRadius: "10px",
  padding: "8px 12px",
  background: "#fff",
  gap: "10px",
};
const inputStyle = { border: "none", outline: "none", flex: 1, fontSize: "16px", color: colors.darkGray };
const buttonStyle = { padding: "12px", background: colors.red, color: "#fff", border: "none", borderRadius: "8px", cursor: "pointer", fontWeight: 600, fontSize: "16px" };
const linkStyle = { color: colors.red, cursor: "pointer", fontSize: "14px", textAlign: "center", marginTop: "5px" };



  
// ---------- Componentes de Formulário ----------
const FormLogin = ({ formData, handleChange, onSubmit, setActiveForm }) => (
  <form onSubmit={onSubmit} style={{ display: "flex", flexDirection: "column", gap: "20px", background: colors.lightGray, padding: "30px", borderRadius: "15px", boxShadow: "0px 10px 25px rgba(0,0,0,0.05)" }}>
    <h2 style={{ color: colors.red, textAlign: "center" }}>Login</h2>
    <div style={inputWrapperStyle}><span style={{ color: colors.red }}>@</span><input type="email" placeholder="Email" value={formData.email} onChange={handleChange} name="email" style={inputStyle}/></div>
    <div style={inputWrapperStyle}><span style={{ color: colors.red }}>🔒</span><input type="password" placeholder="Senha" value={formData.password} onChange={handleChange} name="password" style={inputStyle}/></div>
    <button type="submit" style={buttonStyle}>Logar</button>
    <p style={linkStyle} onClick={() => setActiveForm("resetEmail")}>Esqueci minha senha</p>
    <p style={linkStyle} onClick={() => setActiveForm("register")}>Cadastrar-se</p>
  </form>
);

const FormRegister = ({ formData, handleChange, selectedFile, handleFileChange, preview, onSubmit, setActiveForm,escolherCidade}) => (
  <form onSubmit={onSubmit} style={{ display: "flex", flexDirection: "column", gap: "20px", background: colors.lightGray, padding: "30px", borderRadius: "15px", boxShadow: "0px 10px 25px rgba(0,0,0,0.05)" }}>
    <h2 style={{ color: colors.red, textAlign: "center" }}>Cadastro</h2>
    <div style={inputWrapperStyle}><span style={{ color: colors.red }}>👤</span><input type="text" placeholder="Nome" value={formData.name} onChange={handleChange} name="name" style={inputStyle}/></div>
    <div style={inputWrapperStyle}><span style={{ color: colors.red }}>@</span><input type="email" placeholder="Email" value={formData.email} onChange={handleChange} name="email" style={inputStyle}/></div>
    <div style={inputWrapperStyle}><span style={{ color: colors.red }}>📞</span>
      <PhoneInput
        country={"br"}
        enableSearch
        value={formData.number_phone}
        onChange={(value) => handleChange({ target: { name: "number_phone", value } } as any)}
        inputStyle={{ width: "100%", border: "none", outline: "none", color: colors.darkGray }}
      />
    </div>

    <div style={inputWrapperStyle}>
      <span style={{ color: colors.red }}>🏙️</span>
      {escolherCidade(formData)}
    </div>

    <div style={inputWrapperStyle}><span style={{ color: colors.red }}>🔒</span>
      <input type="password" placeholder="Senha" value={formData.password} onChange={handleChange} name="password" style={inputStyle}/>
    </div>
    <div style={inputWrapperStyle}><input type="file" accept="image/*" onChange={handleFileChange} style={{ flex: 1 }}/></div>
    {preview && <img src={preview} alt="Preview" style={{ width: "100px", borderRadius: "10px", alignSelf: "center" }}/>}


  


    <button type="submit" style={buttonStyle}>Cadastrar</button>
    <p style={linkStyle} onClick={() => setActiveForm("login")}>Voltar ao login</p>
  </form>
);

const FormResetEmail = ({ formData, handleChange, onSubmit, setActiveForm }) => (
  <form onSubmit={onSubmit} style={{ display: "flex", flexDirection: "column", gap: "20px", background: colors.lightGray, padding: "30px", borderRadius: "15px", boxShadow: "0px 10px 25px rgba(0,0,0,0.05)" }}>
    <h2 style={{ color: colors.red, textAlign: "center" }}>Recuperar senha</h2>
    <div style={inputWrapperStyle}><span style={{ color: colors.red }}>@</span><input type="email" placeholder="Email" value={formData.email} onChange={handleChange} name="email" style={inputStyle}/></div>
    <button type="submit" style={buttonStyle}>Validar Email</button>
    <p style={linkStyle} onClick={() => setActiveForm("login")}>Voltar ao login</p>
  </form>
);

const FormResetCode = ({ formDataConfirmed, handleChangeConfirmed, onSubmit }) => (
  <form onSubmit={onSubmit} style={{ display: "flex", flexDirection: "column", gap: "20px", background: colors.lightGray, padding: "30px", borderRadius: "15px", boxShadow: "0px 10px 25px rgba(0,0,0,0.05)" }}>
    <h2 style={{ color: colors.red, textAlign: "center" }}>Digite o código</h2>
    <div style={inputWrapperStyle}><span style={{ color: colors.red }}>🔑</span><input type="text" placeholder="Código" value={formDataConfirmed.confirmed} onChange={handleChangeConfirmed} style={inputStyle}/></div>
    <button type="submit" style={buttonStyle}>Validar Código</button>
  </form>
);

const FormResetPassword = ({ formData, handleChange, onSubmit }) => (
  <form onSubmit={onSubmit} style={{ display: "flex", flexDirection: "column", gap: "20px", background: colors.lightGray, padding: "30px", borderRadius: "15px", boxShadow: "0px 10px 25px rgba(0,0,0,0.05)" }}>
    <h2 style={{ color: colors.red, textAlign: "center" }}>Nova Senha</h2>
    <div style={inputWrapperStyle}><span style={{ color: colors.red }}>🔒</span><input type="password" placeholder="Nova Senha" value={formData.password} onChange={handleChange} name="password" style={inputStyle}/></div>
    <button type="submit" style={buttonStyle}>Redefinir Senha</button>
  </form>
);

// ---------- Componente Principal ----------
const AuthenticationPage = () => {
  const navigate = useNavigate();

  const [activeForm, setActiveForm] = useState<"login" | "register" | "resetEmail" | "resetCode" | "resetPassword">("login");
  const [formData, setFormData] = useState({ name: "", email: "", password: "", number_phone: "", city: "", country: "", imagecompany_logo: "" });
  const [formDataConfirmed, setFormDataConfirmed] = useState({ confirmed: "" });
  const [selectedFile, setSelectedFile] = useState<File | null>(null);
  const [preview, setPreview] = useState<string | null>(null);
  const [valueTokenCod, setValueTokenCod] = useState("");

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => setFormData({ ...formData, [e.target.name]: e.target.value });
  const handleChangeConfirmed = (e: React.ChangeEvent<HTMLInputElement>) => setFormDataConfirmed({ confirmed: e.target.value });
  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (file) {
      setSelectedFile(file);
      const reader = new FileReader();
      reader.onloadend = () => setPreview(reader.result as string);
      reader.readAsDataURL(file);
    } else { setSelectedFile(null); setPreview(null); }
  };

  // ---------- Funções de API ----------
  const handleSubmitLogin = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    try {
      const ApiClient = setupAPIclient();
      const response = await ApiClient.post("/auth/login", { email: formData.email, password: formData.password });
      if (response.data.error) toast.error(response.data.login_error ? "Usuário não encontrado" : "Senha incorreta");
      else { new LocalStorage().saveAuthToken(response.data.token); navigate("/HomePage"); }
    } catch (err) { console.error(err); toast.error("Erro ao tentar login!"); }
  };

  const handleSubmitRegister = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (!formData.name || !formData.email || !formData.password || !formData.number_phone || !formData.city) return toast.warning("Preencha todos os campos obrigatórios");
    const data = new FormData();
    Object.entries(formData).forEach(([key, value]) => data.append(key, value));
    if (selectedFile) data.append("imagecompany_logo", selectedFile);
    const ApiClient = setupAPIclient();
    toast.promise(ApiClient.post("/auth/register", data), {
      pending: "Cadastrando usuário...",
      success: "Cadastro realizado!",
      error: "Erro ao cadastrar usuário!",
    }).then(() => { setFormData({ name: "", email: "", password: "", number_phone: "", city: "", country: "", imagecompany_logo: "" }); setSelectedFile(null); setPreview(null); setActiveForm("login"); });
  };

  const handleVerifyEmail = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (!formData.email) return toast.warning("Preencha o e-mail");
    const ApiClient = setupAPIclient();
    const response = await ApiClient.post("/auth/verify_email", { email: formData.email });
    if (response.data.login_error) toast.warning("E-mail não encontrado!");
    else { setValueTokenCod(response.data.token); setActiveForm("resetCode"); }
  };

  const handleValidationCode = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (!formDataConfirmed.confirmed) return toast.warning("Preencha o código");
    const ApiClient = setupAPIclient();
    const response = await ApiClient.post("/auth/verify_cod", { code: formDataConfirmed.confirmed, token: valueTokenCod });
    if (response.data.success) { toast.success("Código válido! Digite a nova senha."); setActiveForm("resetPassword"); }
    else toast.error("Código inválido");
  };

  const handleResetPassword = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (!formDataConfirmed.confirmed || formData.password.length < 8) return toast.warning("Preencha corretamente os campos");
    const ApiClient = setupAPIclient(valueTokenCod);
    const response = await ApiClient.post("/auth/resetpassword", { code: formDataConfirmed.confirmed, password: formData.password });
    if (!response.data.error) { toast.success("Senha atualizada!"); setActiveForm("login"); }
    else toast.error("Erro ao atualizar senha");
  };

  function escolherCidade(formData:any) {
    const opcoes = [
      { code: "BR", label: "BR — Brasil" },
      { code: "US", label: "US — United States" },
      { code: "PT", label: "PT — Portugal" },
    ];

    return (
      <select
        name="city"
        value={formData.city}
        onChange={(e) => setFormData({ ...formData, city: e.target.value })}
        style={{ 
          ...inputStyle, 
          cursor: "pointer", 
          appearance: "none", 
          backgroundColor: "white" 
        }}
      >
        <option value="" disabled>Escolher pais</option>
        {opcoes.map((o) => (
          <option key={o.code} value={o.label}>
            {o.label}
          </option>
        ))}
      </select>
    );
  }


  return (
    <div style={{ display: "flex", height: "100vh", fontFamily: "Arial, sans-serif" }}>
      {/* Lado esquerdo */}
      <div style={{ flex: 1, background: "#EDEDED", color: colors.lightGray, display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", position: "relative" }}>
        <div style={{ display: "flex", gap: "15px", marginBottom: "30px" }}>
          <div style={{ width: "50px", height: "70px", background: colors.red, borderRadius: "5px", animation: "contractBounce 1.5s infinite" }}></div>
          <div style={{ width: "50px", height: "70px", background: colors.red, borderRadius: "5px", animation: "contractBounce 1.5s infinite", animationDelay: "0.3s" }}></div>
          <div style={{ width: "50px", height: "70px", background: colors.red, borderRadius: "5px", animation: "contractBounce 1.5s infinite", animationDelay: "0.6s" }}></div>
        </div>
        <div style={{ marginTop: "40px", textAlign: "center" }}>
          <h1 style={{ color: colors.red, fontWeight: 700 }}>GESTÃO DE CONTRATO - BIM</h1>
          <h3 style={{ color: colors.darkGray, margin: "5px 0", fontWeight: 500 }}>Desenvolvimento em TI LTDA - ME</h3>
          <p style={{ color: colors.darkGray, margin: "2px 0" }}>CNPJ: 30.937.045/0001-58</p>
          <p style={{ color: colors.darkGray, margin: "2px 0" }}>Site: byteinmotion.com.br</p>
        </div>
      </div>

      {/* Lado direito */}
      <div style={{ flex: 1, display: "flex", justifyContent: "center", alignItems: "center", background: colors.lightGray }}>
        <div style={{ width: "80%", maxWidth: "400px" }}>
          {activeForm === "login" && <FormLogin formData={formData} handleChange={handleChange} onSubmit={handleSubmitLogin} setActiveForm={setActiveForm}/>}
          {activeForm === "register" && <FormRegister formData={formData} handleChange={handleChange} 
          selectedFile={selectedFile} handleFileChange={handleFileChange} preview={preview}
           onSubmit={handleSubmitRegister} setActiveForm={setActiveForm} escolherCidade={escolherCidade}/>}
          {activeForm === "resetEmail" && <FormResetEmail formData={formData} handleChange={handleChange} onSubmit={handleVerifyEmail} setActiveForm={setActiveForm}/>}
          {activeForm === "resetCode" && <FormResetCode formDataConfirmed={formDataConfirmed} handleChangeConfirmed={handleChangeConfirmed} onSubmit={handleValidationCode}/>}
          {activeForm === "resetPassword" && <FormResetPassword formData={formData} handleChange={handleChange} onSubmit={handleResetPassword}/>}
        </div>
      </div>
    </div>
  );
};

// ---------- Keyframes CSS ----------
const styleSheet = document.styleSheets[0];
const keyframes = `
@keyframes contractBounce {
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-15px) rotate(5deg); }
}
`;
styleSheet.insertRule(keyframes, styleSheet.cssRules.length);

export default AuthenticationPage;
